module.exports = __webpack_public_path__ + "img/transfer-bg.439dd7ef.png";